import React, { Component } from "react";

import getRestaurantsLink from "../../../lib/getRestaurantsLink";

import { GlobalConsumer } from "../../../context/GlobalContext";

export default class CommonHeader extends Component {
  state = {
    href: "/"
  };
  componentDidMount() {
    let href = getRestaurantsLink();
    this.setState({
      href
    });
  }
  activeClass = route => {
    const { active } = this.props;
    return (active && active === route && "active") || "";
  };
  render() {
    const { href } = this.state;
    const { className } = this.props;
    return (
      <div
        className={`main-nav d-flex justify-content-between align-items-center visible-xs ${className ||
          ""}`}
      >
        <a href={href} className={this.activeClass("restaurantList")}>
          <i className="icon icon-rest" />
          Restaurant
        </a>
        <a href="/search" className={this.activeClass("search")}>
          <i className="icon icon-search" />
          Search
        </a>
        <GlobalConsumer>
          {({ user }) => {
            return (
              <a
                href={`${(user && user.uid && "/profile?rewards") ||
                  "/rewards"}`}
                className={this.activeClass("rewards")}
              >
                <i className="icon icon-rewards" />
                Rewards
              </a>
            );
          }}
        </GlobalConsumer>

        <a href="/profile?orders" className={this.activeClass("orders")}>
          <i className="icon icon-orders" />
          Orders
        </a>
        <a href="/profile" className={this.activeClass("profile")}>
          <i className="icon icon-profile-white" />
          Profile
        </a>
      </div>
    );
  }
}
